import { dtoToRgObject } from '../../dto-to-rg-object.js';

const dtoToPlot = (dto, versions) => {
    // upgrade: add `zonePolyIndex` if not defined
    if (!('zonePolyIndex' in dto.data)) {
        dto = {
            ...dto,
            data: {
                ...dto.data,
                zonePolyIndex: 0
            }
        };
    }
    return dtoToRgObject(dto, { versions, partials: {}, top: false });
};

export { dtoToPlot };
//# sourceMappingURL=dto-to-plot.js.map
